import { UnitTableFilters } from "./filter/UnitTableFilters";
import { UnitTableSort } from "./sort/UnitTableSort";
import { CategoryPillFilters } from "./filter/CategoryPillFilters";
import { MoreFiltersButton } from "./filter/MoreFiltersButton";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { WidgetLayout } from "@/types/enums";
import type { UnitCategory, UnitFeature } from "@/types";

interface UnitTableControlsProps {
    features: UnitFeature[];
    categories: UnitCategory[];
    categoriesLoading?: boolean;
}
export const UnitTableControls = ({
    features,
    categories,
    categoriesLoading = false,
}: UnitTableControlsProps) => {
    const displayOptions = useDisplayOptionContext();
    const isLayout2 = displayOptions.widgetLayout === WidgetLayout.LAYOUT_2;

    if (isLayout2) {
        return (
            <div className="layout-2-filter-stack">
                <div className="unit-table-controls layout-2-filter-bar">
                    <CategoryPillFilters
                        categories={categories}
                        categoriesLoading={categoriesLoading}
                    />
                    <MoreFiltersButton
                        features={features}
                        categories={categories}
                    />
                </div>
                <div className="layout-2-filter-help">
                    <span className="layout-2-filter-help__prompt">Need help? </span>
                    <a href="/size-guide" className="layout-2-filter-help__link">
                        Size Guide
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="unit-table-controls tw:flex tw:flex-row tw:space-x-3 tw:items-end">
            <UnitTableFilters features={features} categories={categories} />
            <UnitTableSort />
        </div>
    );
};
